<template>
  <router-view />
</template>

<script>
export default {
  name: 'App'
};
</script>

<style>
html {
  overflow-y: auto !important;
}

html,
body,
#app {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}
</style>
